import React, { useContext, useEffect, useState } from 'react';
import * as yup from 'yup';

import { HttpMethods, FetchContext, ApiRoutes } from '../../../../contexts';
import { useAggregatedState } from '../../../../../helpers';

export const ContractContext = React.createContext(null);

const { Provider } = ContractContext;
export const ContractProvider = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
    });

    return (
        <Provider value={{
            state
        }}>
            {props.children}
        </Provider>
    );
}